import {action, observable} from 'mobx';

import {message} from 'antd';
import {BaseStore} from './base';
import * as api from '../helpers/api';
import {
  addArchiveCar,
  addCar,
  addRequestCar,
  exportCars,
  fcheck,
  fcheckArchiveCar,
  fcheckRequestCar,
  moveCars,
  orderUpClients,
  removeArchiveCars,
  removeCars,
  removeRequestCars,
  reorderClient,
  reorderMany,
  setSendSms,
  updateMany
} from '../helpers/api';
import {save} from 'save-file'

export class ClientsStore extends BaseStore {
  @observable ourClients = null;
  @observable reqClients = null;
  @observable arcClients = null;

  @observable isLoadingClients = false;

  @action async loadAll(force = false) {
    if(!force && (this.ourClients || this.reqClients)) {
      return ;
    }

    console.log('loadAll');

    this.isLoadingClients = true;
    const res = await api.getAllClients();
    if(res) {
      this.ourClients = res.our;
      this.reqClients = res.req;
      this.arcClients = res.arc;
    }

    this.isLoadingClients = false;
  }

  @action async add(number, data, category = 'our') {
    if(category === 'our') {
      return this.addCar(number, data);
    } else if(category === 'arc') {
      return this.addArc(number, data);
    } else {
      return this.addReq(number, data);
    }
  }

  @action async addCar(number, data) {
    const res = await addCar(number, data);
    if(res) {
      this.ourClients.unshift(res.car);
      return true;
    }
    return false;
  }

  @action async addReq(number, data) {
    const res = await addRequestCar(number, data);
    if(res) {
      this.reqClients.unshift(res.req);
      return true;
    }
    return false;
  }


  @action async addArc(number, data) {
    const res = await addArchiveCar(number, data);
    if(res) {
      this.arcClients.unshift(res.arc);
      return true;
    }
    return false;
  }


  @action async removeReq(cids) {
    const hide = message.loading('Удаление..', 0);
    const data = await removeRequestCars(cids);
    const rows = this.reqClients.slice(0).filter(i => cids.indexOf(i.cid) === -1);

    if(data) {
      this.reqClients = rows;
    }

    hide();
    return data;
  }


  @action async removeArc(cids) {
    const hide = message.loading('Удаление..', 0);
    const data = await removeArchiveCars(cids);
    const rows = this.arcClients.slice(0).filter(i => cids.indexOf(i.cid) === -1);

    if(data) {
      this.arcClients = rows;
    }

    hide();
    return data;
  }


  @action async remove(cids) {
    const hide = message.loading('Удаление..', 0);
    const data = await removeCars(cids);
    const rows = this.ourClients.slice(0).filter(i => cids.indexOf(i.cid) === -1);

    if(data) {
      this.ourClients = rows;
    }

    hide();
    return data;
  }


  @action async check(row) {
    const res = await fcheck(row.number);

    console.log('check pass', res);
    if(res) {
      if(!res.car)
        return true;

      const rows = this.ourClients.slice(0);
      const index = rows.findIndex(r => r.id === res.car.id);
      rows[index] = res.car;

      this.ourClients = rows;
      return true;
    }

    return false;
  }

  @action async checkReq(row) {
    const res = await fcheckRequestCar(row.number);

    if(res) {
      if(!res.car)
        return true;

      const rows = this.reqClients.slice(0);
      const index = rows.findIndex(r => r.id === res.car.id);
      rows[index] = res.car;

      this.reqClients = rows;
      return true;
    }

    return false;
  }


  @action async checkArc(row) {
    const res = await fcheckArchiveCar(row.number);

    if(res) {
      if(!res.car)
        return true;

      const rows = this.arcClients.slice(0);
      const index = rows.findIndex(r => r.id === res.car.id);
      rows[index] = res.car;

      this.arcClients = rows;
      return true;
    }

    return false;
  }

  @action async export(numbers, type) {
    const res = await exportCars(numbers, type);
    if(res) {
      await save(res.data, 'clients.xlsx');
    } else {
      console.error('erro request', res);
    }
  }

  @action async move(numbers, from, to) {
    const res = await moveCars(numbers, from, to);
    if (res) {
      // force reload
      await this.loadAll(true);
    }

    return res;
  }

  @action async reorderMany(page, ids, to) {
    console.log('on reorder-many', page, ids, to);

    const res = await reorderMany(page, ids, to);
    if(res) {
      await this.loadAll(true);
      return true;
    }

    return false;
  }

  @action async reorder(page, from, to) {
    console.log('on reorder', page, from, to);

    const res = await reorderClient(page, from, to);
    if(res) {
      await this.loadAll(true);
      return true;
    }

    return false;
  }

  @action async setSendSms(page, numbers, state) {
    const rows = this.getArrByPage(page).slice(0);

    const hide = message.loading('Сохранение изменений..', 0);
    const res = await setSendSms(page, numbers, state);
    if(res) {
      for(const row of rows) {
        if(numbers.indexOf(row.number) > -1) {
          row.sendSms = state;
        }
      }

      this.setArrByPage(page, rows);
      message.success('Сохранено');
    }

    hide();
  }

  async orderUp(page, numbers) {
    const res = await orderUpClients(page, numbers);
    if(res) {
      location.reload();
    }
  }

  async updateMany(page, ids, data) {
    const hide = message.loading('Обновление данных...');
    const res = await updateMany(page, ids, data);

    if (res) {
      // force-reload
      const rows = this.getArrByPage(page).slice(0);
      for (const row of rows) {
        if (ids.indexOf(row.id) > -1) {
          row[data.fieldName] = data.value;
        }
      }

      this.setArrByPage(page, rows);

      hide();
      message.success('Данные выбранных машин изменены');
    }

    return res;
  }

  getArrByPage(page) {
    return this[`${page}Clients`];
  }

  setArrByPage(page, val) {
    this[`${page}Clients`] = val;
  }


}



// WEBPACK FOOTER //
// ./src/stores/clients-store.js